import { defineStore } from 'pinia';
import { trendingQueriesFallback } from 'config';
import { FETCH_TRENDING_QUERIES, SET_TRENDING_QUERIES } from '#shared/types/actions';
import useSearchSuggestions from '~/composables/dumb/useSearchSuggestions';

export const scaledArms: Record<string, number> = {
  mcom: 1,
  bcom: 2,
};

export const useNavTrendingQueries = defineStore('navTrendingQueries', {
  state: () => ({
    trendingData: [] as string[],
    isLoadingTrending: false,
  }),
  actions: {
    [SET_TRENDING_QUERIES](payload) {
      this.trendingData = payload;
    },
    async [FETCH_TRENDING_QUERIES]() {
      const { getTrendingQueries } = useSearchSuggestions();
      const envProps = useEnvProps();

      this.isLoadingTrending = true;

      const { brand, hostlink } = envProps;

      try {
        const resultData = await getTrendingQueries({
          siteName: brand.toUpperCase(),
          expNumber: scaledArms[brand],
          hostlink,
        });

        if (Array.isArray(resultData) && resultData.length > 0) {
          this[SET_TRENDING_QUERIES](resultData);
        } else {
          this[SET_TRENDING_QUERIES](trendingQueriesFallback);
        }
      } catch (e) {
        console.error('Failed to fetch trending queries', e);
        this[SET_TRENDING_QUERIES](trendingQueriesFallback);
      } finally {
        this.isLoadingTrending = false;
      }
    },
  },
});
